import { useState, useEffect } from "react";
import { setToken } from "../api";
import { api } from "../api";

const BASE = "https://clavex.objetivabroker.es/api";

const EyeIcon = ({ open }) => (
  <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round">
    {open
      ? <><path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/><circle cx="12" cy="12" r="3"/></>
      : <path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24M1 1l22 22"/>}
  </svg>
);

export default function Login({ onLogin }) {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  const [users, setUsers]       = useState([]);
  const [sel, setSel]           = useState(null);
  const [pwd, setPwd]           = useState("");
  const [showPwd, setShowPwd]   = useState(false);
  const [err, setErr]           = useState("");
  const [loading, setLoading]   = useState(false);
  const [mode, setMode]         = useState("dark");
  const [tempToken, setTempToken]     = useState(null);
  const [totpCode, setTotpCode]       = useState("");
  const [totpErr, setTotpErr]         = useState("");
  const [totpLoading, setTotpLoading] = useState(false);

  useEffect(() => {
    const h = () => setIsMobile(window.innerWidth <= 768);
    window.addEventListener('resize', h);
    return () => window.removeEventListener('resize', h);
  }, []);

  useEffect(() => {
    fetch(`${BASE}/auth/users/public`)
      .then(r => r.json())
      .then(setUsers)
      .catch(() => {});
  }, []);

  useEffect(() => {
    if (!document.getElementById("syne-font")) {
      const l = document.createElement("link");
      l.id = "syne-font"; l.rel = "stylesheet";
      l.href = "https://fonts.googleapis.com/css2?family=Syne:wght@700&display=swap";
      document.head.appendChild(l);
    }
  }, []);
  const D = mode === "dark";

  const handleLogin = async () => {
    if (!sel) { setErr("Selecciona un perfil"); return; }
    if (!pwd) { setErr("Introduce la contraseña"); return; }
    setLoading(true); setErr("");
    try {
      const data = await api.login(sel.slug, pwd);
      if (data.requires_2fa) {
        setTempToken(data.temp_token);
      } else {
        onLogin({ ...data.user, theme: mode });
      }
    } catch (e) {
      const msg = e?.message || e?.detail || "";
      setErr(typeof msg === 'string' && msg ? msg : "Credenciales incorrectas");
    } finally { setLoading(false); }
  };

  const handleTotp = async () => {
    if (totpCode.length !== 6) return;
    setTotpLoading(true); setTotpErr("");
    try {
      const BASE = window.location.hostname === "localhost"
        ? "http://localhost:8001"
        : `${window.location.protocol}//${window.location.host}/api`;
      const r = await fetch(`${BASE}/auth/2fa/validate`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        credentials: "include",
        body: JSON.stringify({ temp_token: tempToken, code: totpCode })
      });
      const data = await r.json();
      if (!r.ok) throw new Error(data.detail || "Código incorrecto");
      setToken(data.access_token);
      onLogin({ ...data.user, theme: mode });
    } catch (e) {
      setTotpErr(e.message || "Código incorrecto");
      setTotpCode("");
    } finally { setTotpLoading(false); }
  };

  const C = {
    page:       D ? "#0D0B08" : "#EDE8DF",
    heroBg:     D ? "#080705" : "#F5F0E8",
    heroBorder: D ? "#2A2418" : "#DDD5C5",
    rightBg:    D ? "#100E0B" : "#EDE8DF",
    tileBg:     D ? "#0D0B08" : "#F5F0E8",
    tileActive: D ? "#1A1208" : "#FAF7F2",
    tileBorder: D ? "#1E1A12" : "#DDD5C5",
    tileActiveBorder: "#C9A870",
    text:       D ? "#F2EFE9" : "#1A1612",
    textSub:    D ? "#E8C99A" : "#2A1E10",
    textMute:   D ? "#C4A070" : "#4A3A28",
    inputBg:    D ? "#0A0805" : "#F5F0E8",
    inputBorder:D ? "#2A2418" : "#DDD5C5",
    inputText:  D ? "#3A3028" : "#B0A090",
    btnBg:      D ? "none"    : "#C9A870",
    btnColor:   D ? "#C9A870" : "#F5F0E8",
    btnBorder:  "#C9A870",
    eyebrowColor: D ? "#CCA878" : "#4A3A28",
    ruleColor:  D ? "#5C4830" : "#C4A96A",
    ruleText:   D ? "#C4A070" : "#5A4A35",
    bottomBar:  D ? "#C4A070" : "#6A5A45",
    toggleColor:D ? "#C4A070" : "#6A5A45",
    geoOpacity: D ? "0.04"    : "0.08",
    logoText:   D ? "#F2EFE9" : "#1A1612",
  };

  return (
    <div style={{ minHeight: "100vh", background: C.page, display: "flex", alignItems: "center", justifyContent: "center", fontFamily: "'Plus Jakarta Sans', sans-serif", transition: "background 0.3s" }}>
      <div className="login-container" style={{ display: "flex", alignItems: "stretch", width: isMobile ? "100vw" : 860, minHeight: "100vh", borderRadius: 0, overflow: "hidden" }}>

        {/* LEFT */}
        <div className="login-left" style={{ flex: 1, background: C.heroBg, display: isMobile ? "none" : "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", padding: "48px 32px", borderRight: `1px solid ${C.heroBorder}`, position: "relative", transition: "background 0.3s" }}>
          <svg style={{ position: "absolute", top: 0, left: 0, width: "100%", height: "100%", opacity: C.geoOpacity, pointerEvents: "none" }} viewBox="0 0 300 400" fill="none">
            <circle cx="150" cy="200" r="180" stroke="#C9A870" strokeWidth="0.5"/>
            <circle cx="150" cy="200" r="130" stroke="#C9A870" strokeWidth="0.5"/>
            <circle cx="150" cy="200" r="80"  stroke="#C9A870" strokeWidth="0.5"/>
            <line x1="150" y1="20"  x2="150" y2="380" stroke="#C9A870" strokeWidth="0.3"/>
            <line x1="20"  y1="200" x2="280" y2="200" stroke="#C9A870" strokeWidth="0.3"/>
          </svg>

          <div style={{ position: "relative", zIndex: 1, textAlign: "center" }}>
            <svg viewBox="-20 -20 240 240" width="180" height="180" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ marginBottom: 20 }}>
              <circle cx="100" cy="100" r="115" stroke="#7A6040" strokeWidth="0.8"/>
              <line x1="100" y1="-15"  x2="100" y2="-33"  stroke="#C9A870" strokeWidth="1.5" strokeLinecap="round"/>
              <line x1="100" y1="215"  x2="100" y2="233"  stroke="#C9A870" strokeWidth="1.5" strokeLinecap="round"/>
              <line x1="-15" y1="100"  x2="-33" y2="100"  stroke="#C9A870" strokeWidth="1.5" strokeLinecap="round"/>
              <line x1="215" y1="100"  x2="233" y2="100"  stroke="#C9A870" strokeWidth="1.5" strokeLinecap="round"/>
              <line x1="181.3" y1="18.7"  x2="193.6" y2="6.4"   stroke="#7A6040" strokeWidth="0.8"/>
              <line x1="18.7"  y1="181.3" x2="6.4"   y2="193.6" stroke="#7A6040" strokeWidth="0.8"/>
              <line x1="18.7"  y1="18.7"  x2="6.4"   y2="6.4"   stroke="#7A6040" strokeWidth="0.8"/>
              <line x1="181.3" y1="181.3" x2="193.6" y2="193.6" stroke="#7A6040" strokeWidth="0.8"/>
              <circle cx="100" cy="100" r="96" stroke="#1E1E1E" strokeWidth="0.8"/>
              <circle cx="100" cy="100" r="95" fill={D ? "#080808" : "#F0EBE0"} fillOpacity="0.9"/>
              <polygon points="100,30 153,62.5 153,127.5 100,160 47,127.5 47,62.5" stroke="#C9A870" strokeWidth="1.8" fill={D ? "#0D0C09" : "#EDE8DF"}/>
              <polygon points="100,40 143,65 143,125 100,150 57,125 57,65" stroke="#7A6040" strokeWidth="0.9" fill="none"/>
              <circle cx="100" cy="85" r="22" stroke="#C9A870" strokeWidth="1.8" fill={D ? "#080808" : "#F0EBE0"}/>
              <rect x="89" y="104" width="22" height="34" fill={D ? "#080808" : "#F0EBE0"}/>
              <line x1="89"  y1="104" x2="89"  y2="138" stroke="#C9A870" strokeWidth="1.8"/>
              <line x1="111" y1="104" x2="111" y2="138" stroke="#C9A870" strokeWidth="1.8"/>
              <line x1="89"  y1="138" x2="111" y2="138" stroke="#C9A870" strokeWidth="1.8"/>
            </svg>
            <div style={{ lineHeight: 1.1, textAlign: "center" }}>
              <div style={{ fontFamily: "Syne, sans-serif", fontSize: 38, fontWeight: 700, letterSpacing: 6 }}>
                <span style={{ color: "#C9A870" }}>OBJ</span><span style={{ color: C.logoText, marginLeft: 10 }}>CLA</span><span style={{ color: "#C9A870" }}>VEX</span>
              </div>
            </div>
            <div style={{ display: "flex", alignItems: "center", gap: 10, justifyContent: "center", marginTop: 10 }}>
              <div style={{ height: 1, width: 32, background: C.ruleColor }}/>
              <span style={{ fontFamily: "Plus Jakarta Sans, sans-serif", fontSize: 10, letterSpacing: 3, color: C.ruleText, textTransform: "uppercase" }}>Credential Vault · Corporate Security</span>
              <div style={{ height: 1, width: 32, background: C.ruleColor }}/>
            </div>
          </div>

          <div style={{ position: "absolute", bottom: 28, display: "flex", gap: 16, fontFamily: "Plus Jakarta Sans, sans-serif", fontSize: 10, letterSpacing: 2.5, color: C.bottomBar, textTransform: "uppercase" }}>
            <span>Protected</span><span>·</span><span>Encrypted</span><span>·</span><span>Yours</span>
          </div>
        </div>

        {/* RIGHT */}
        <div className="login-right" style={{ width: isMobile ? "100vw" : 320, padding: isMobile ? "48px 24px" : "48px 36px", display: "flex", flexDirection: "column", justifyContent: "center", background: C.rightBg, transition: "background 0.3s", boxSizing: "border-box" }}>
          <div style={{ marginBottom: 28 }}>
            <div style={{ fontFamily: "Plus Jakarta Sans, sans-serif", fontSize: 11, letterSpacing: 3, color: C.eyebrowColor, textTransform: "uppercase", marginBottom: 8 }}>Objetiva Broker</div>
            <div style={{ fontSize: 26, fontWeight: 600, color: C.text, letterSpacing: "-0.3px" }}>Acceso seguro</div>
          </div>

          <div style={{ fontFamily: "Plus Jakarta Sans, sans-serif", fontSize: 10, letterSpacing: 2.5, color: C.eyebrowColor, textTransform: "uppercase", marginBottom: 10 }}>Selecciona tu perfil</div>
          <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 8, marginBottom: 24 }}>
            {users.map(u => (
              <button key={u.slug} onClick={() => { setSel(u); setErr(""); }}
                style={{ background: sel?.slug === u.slug ? C.tileActive : C.tileBg, border: `1px solid ${sel?.slug === u.slug ? C.tileActiveBorder : C.tileBorder}`, padding: "14px 10px", display: "flex", flexDirection: "column", alignItems: "center", gap: 8, cursor: "pointer", transition: "border-color 0.15s" }}>
                <div style={{ width: 36, height: 36, borderRadius: "50%", background: D ? "#0A0705" : "#EDE8DF", border: `1px solid ${sel?.slug === u.slug ? "#C9A870" : C.tileBorder}`, display: "flex", alignItems: "center", justifyContent: "center", fontSize: 10, fontWeight: 700, color: sel?.slug === u.slug ? u.color : C.textSub, letterSpacing: 0.5 }}>{u.avatar}</div>
                <div style={{ fontSize: 13, fontWeight: 600, color: sel?.slug === u.slug ? C.text : C.textSub, textAlign: "center", lineHeight: 1.3 }}>{u.name}</div>
                <div style={{ fontFamily: "Plus Jakarta Sans, sans-serif", fontSize: 9, letterSpacing: 1.5, color: sel?.slug === u.slug ? "#C9A870" : C.textMute, textTransform: "uppercase" }}>{u.role === "admin" ? "👑 " : ""}{u.dept}</div>
              </button>
            ))}
          </div>

          <div style={{ fontFamily: "Plus Jakarta Sans, sans-serif", fontSize: 10, letterSpacing: 2.5, color: C.eyebrowColor, textTransform: "uppercase", marginBottom: 10 }}>Contraseña maestra</div>
          <div style={{ position: "relative", marginBottom: 20 }}>
            <input type={showPwd ? "text" : "password"} value={pwd}
              onChange={e => { setPwd(e.target.value); setErr(""); }}
              onKeyDown={e => e.key === "Enter" && handleLogin()}
              placeholder="Contraseña maestra"
              style={{ width: "100%", background: C.inputBg, border: `1px solid ${C.inputBorder}`, padding: "13px 42px 13px 16px", color: C.text, fontFamily: "'Plus Jakarta Sans', sans-serif", fontSize: 15, letterSpacing: 3, outline: "none", boxSizing: "border-box", transition: "background 0.3s" }}
            />
            <button onClick={() => setShowPwd(s => !s)} style={{ position: "absolute", right: 12, top: "50%", transform: "translateY(-50%)", background: "none", border: "none", color: C.textMute, cursor: "pointer", display: "flex", alignItems: "center" }}>
              <EyeIcon open={showPwd} />
            </button>
          </div>

          {!tempToken ? (
            <>
              <button onClick={handleLogin} disabled={loading}
                style={{ width: "100%", padding: 13, background: C.btnBg, border: `1px solid ${C.btnBorder}`, color: C.btnColor, cursor: "pointer", fontFamily: "Plus Jakarta Sans, sans-serif", fontSize: 12, fontWeight: D ? 500 : 600, letterSpacing: 3, textTransform: "uppercase", transition: "background 0.3s" }}>
                {loading ? "Verificando..." : "Acceder a la bóveda"}
              </button>
              {err && <div style={{ fontFamily: "Plus Jakarta Sans, sans-serif", fontSize: 10, letterSpacing: 1.5, color: "#8B3A3A", textTransform: "uppercase", marginTop: 10, textAlign: "center" }}>{err}</div>}
            </>
          ) : (
            <>
              <div style={{ fontFamily: "Plus Jakarta Sans, sans-serif", fontSize: 10, letterSpacing: 2.5, color: C.eyebrowColor, textTransform: "uppercase", marginBottom: 10 }}>Verificación en dos pasos</div>
              <p style={{ fontSize: 12, color: C.textMute, fontFamily: "Plus Jakarta Sans, sans-serif", letterSpacing: 1, marginBottom: 16, lineHeight: 1.6 }}>
                Introduce el código de 6 dígitos de tu app autenticadora.
              </p>
              <input
                value={totpCode}
                onChange={e => { setTotpCode(e.target.value.replace(/\D/g, "").slice(0, 6)); setTotpErr(""); }}
                onKeyDown={e => e.key === "Enter" && handleTotp()}
                placeholder="000000"
                maxLength={6}
                autoFocus
                style={{ width: "100%", background: C.inputBg, border: `1px solid ${C.inputBorder}`, padding: "13px 16px", color: C.text, fontFamily: "Plus Jakarta Sans, sans-serif", fontSize: 24, letterSpacing: 8, outline: "none", boxSizing: "border-box", textAlign: "center", marginBottom: 16 }}
              />
              <button onClick={handleTotp} disabled={totpLoading || totpCode.length !== 6}
                style={{ width: "100%", padding: 13, background: C.btnBg, border: `1px solid ${C.btnBorder}`, color: C.btnColor, cursor: "pointer", fontFamily: "Plus Jakarta Sans, sans-serif", fontSize: 12, fontWeight: D ? 500 : 600, letterSpacing: 3, textTransform: "uppercase", opacity: totpCode.length !== 6 ? 0.5 : 1 }}>
                {totpLoading ? "Verificando..." : "Confirmar código"}
              </button>
              {totpErr && <div style={{ fontFamily: "Plus Jakarta Sans, sans-serif", fontSize: 10, letterSpacing: 1.5, color: "#8B3A3A", textTransform: "uppercase", marginTop: 10, textAlign: "center" }}>{totpErr}</div>}
              <button onClick={() => { setTempToken(null); setTotpCode(""); setTotpErr(""); }}
                style={{ marginTop: 12, background: "none", border: "none", cursor: "pointer", fontFamily: "Plus Jakarta Sans, sans-serif", fontSize: 10, letterSpacing: 1.5, color: C.textMute, textTransform: "uppercase", textAlign: "center", width: "100%" }}>
                ← Volver al login
              </button>
            </>
          )}

          <button onClick={() => setMode(m => m === "dark" ? "light" : "dark")}
            style={{ marginTop: 24, background: "none", border: "none", cursor: "pointer", fontFamily: "Plus Jakarta Sans, sans-serif", fontSize: 10, letterSpacing: 1.5, color: C.toggleColor, textTransform: "uppercase", textAlign: "center" }}>
            {D ? "☀ Cambiar a modo claro" : "☾ Cambiar a modo oscuro"}
          </button>
        </div>
      </div>
    </div>
  );
}
